import React, { memo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SignatureCanvas from 'react-signature-canvas';

import { useStyles } from './styles';
import Modal from '../Modal';

export interface ISignatureModalProps {
  isLoading?: boolean;
  modalStyleClass?: string;
  saveLabel?: string;
  saveButtonStyleClass?: string;
  onClose: () => void;
  onProceed: (data: string) => void;
  signatureFormat?: any;
}

const SignatureModal = ({
  isLoading,
  modalStyleClass = '',
  saveLabel,
  saveButtonStyleClass,
  onClose,
  onProceed,
  signatureFormat = 'image/png',
}: ISignatureModalProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [hasSigned, setHasSigned] = useState(false);
  const signPadRef = useRef(null);

  const onNext = () => {
    const signData = signPadRef.current.getTrimmedCanvas().toDataURL(signatureFormat);
    onProceed(signData);
  };

  const onClear = () => {
    setHasSigned(false);
    signPadRef?.current?.clear();
  };

  return (
    <Modal
      title={t('signature.title')}
      Content={
        <>
          <div className={classes.canvasWrapper}>
            <SignatureCanvas
              penColor="black"
              onEnd={() => setHasSigned(true)}
              canvasProps={{ className: classes.signPad }}
              ref={signPadRef}
              autoFocus={true}
            />
          </div>
          <p className={classes.descriptionText}>{t('signature.description')}</p>
        </>
      }
      actionButtons={[
        {
          label: t('signature.clear'),
          variant: 'outlined',
          disabled: !hasSigned || isLoading,
          isLoading: false,
          onClick: onClear,
          styleClass: classes.clearButton,
          testId: 'signature-clear-button',
        },
        {
          label: saveLabel ?? t('signature.signNext'),
          disabled: !hasSigned || isLoading,
          isLoading: isLoading,
          onClick: onNext,
          testId: 'signature-sign-button',
          styleClass: `${classes.nextButton}${saveButtonStyleClass ? ` ${saveButtonStyleClass}` : ''}`,
        },
      ]}
      modalStyleClass={`${classes.modal} ${modalStyleClass}`}
      modalContentStyleClass={`${classes.modalContent}`}
      onClose={!isLoading && onClose}
    />
  );
};

export default memo(SignatureModal);
